<template>
  <q-expansion-item
    :model-value="modelValue"
    data-test-id="kitchen-stage-expansion-item"
    class="no-wrap"
    :style="orderCardStyles"
    :expand-icon-class="{ 'text-white': orderCardStyles.color === 'white' }"
    @update:model-value="value => $emit('update:model-value', value)"
  >
    <template #header>
      <q-item-section>
        <div class="row items-center">
          <div
            class="col-6 row items-center q-gutter-xs"
            @click="handleStageClick"
          >
            <span class="text-subtitle2 text-italic">
              {{ stage }}
            </span>
            <q-badge
              :label="orderItems.length"
              color="primary"
              :text-color="$isColorDark(currentSite.primaryColor) ? 'white' : 'dark'"
              rounded
            />
          </div>
          <q-space />
        </div>
      </q-item-section>
    </template>
  </q-expansion-item>
</template>

<script>
import KitchenCardMixin from 'src/modules/kds/components/kitchen-card/mixins/KitchenCardMixin'

export default {
  name: 'KitchenStageExpansionItem',
  mixins: [KitchenCardMixin],
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    stage: {
      type: String,
      required: true
    }
  },
  emits: ['update:model-value'],
  methods: {
    handleStageClick (event) {
      if (!this.modelValue) return

      event.stopPropagation()
      this.promptOrderActions()
    }
  }
}
</script>
